import { render } from "./InputColor.vue?vue&type=template&id=d8094744&scoped=true"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"

import "./InputColor.vue?vue&type=style&index=0&id=d8094744&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8094744"]])

export default __exports__